import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { localizePath } from '../../helper/localizedPath';

export default function Breadcrumbs({ items }) {
  const { i18n } = useTranslation();
  const language = i18n.language === 'en' ? 'en' : 'cs';

  if (!items || items.length === 0) return null;

  const schemaItems = items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.label,
    ...(item.href ? { item: `https://www.stablerecords.cz${localizePath(item.href, language)}` } : {}),
  }));

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: schemaItems,
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <nav aria-label="breadcrumb" style={{ padding: '12px 0', fontSize: '14px', opacity: 0.7 }}>
        <ol style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
          {items.map((item, index) => (
            <li key={index} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              {index < items.length - 1 ? (
                <>
                  <Link to={localizePath(item.href, language)} style={{ color: 'inherit', textDecoration: 'underline' }}>
                    {item.label}
                  </Link>
                  <span aria-hidden="true">›</span>
                </>
              ) : (
                <span aria-current="page">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}
